import {
  isUnrestrictedAdminRole,
  normalizeRoleSlug,
} from "../../../public/utils/roleAccess";

/** Shared cheque workspace UI — admin (full) vs restricted (non-admin). */
export const CHEQUE_WORKSPACE_VARIANTS = Object.freeze({
  ADMIN: "admin",
  STAFF: "staff",
});

export const CHEQUE_WORKSPACE_CONFIG = Object.freeze({
  [CHEQUE_WORKSPACE_VARIANTS.ADMIN]: {
    pageTag: "Cheque issues",
    heroEyebrow: "Office Administration",
    heroTitle: "Cheque issues",
    heroSub:
      "Cheque register, status updates, export, and master tables (banks, statuses, types) on one screen.",
    canExport: true,
    excludeStatusNames: [],
    summaryVariant: "admin",
    showMasters: true,
  },
  [CHEQUE_WORKSPACE_VARIANTS.STAFF]: {
    pageTag: "Cheque issues",
    heroEyebrow: "Cheque Operations",
    heroTitle: "Cheque issues",
    heroSub:
      "Record and track cheques, mark items as cleared, and update status. You cannot delete records, permanently cancel cheques, export the full register, or change cleared entries.",
    canExport: false,
    excludeStatusNames: ["cancelled", "canceled"],
    summaryVariant: "staff",
    showMasters: false,
  },
});

export function isChequeRowLocked(row) {
  const name = String(row?.status_name || "").toLowerCase();
  return name.includes("cleared") || name.includes("cancelled") || name.includes("canceled");
}

export function resolveChequeWorkspaceVariant(roleSlug) {
  const slug = normalizeRoleSlug(roleSlug);
  const isAdmin = isUnrestrictedAdminRole(slug);
  return {
    isAdmin,
    variant: isAdmin
      ? CHEQUE_WORKSPACE_VARIANTS.ADMIN
      : CHEQUE_WORKSPACE_VARIANTS.STAFF,
    showMasters: isAdmin,
  };
}

export function filterChequeStatuses(statuses, excludeNames = []) {
  if (!excludeNames?.length) return statuses || [];
  const blocked = new Set(excludeNames.map((n) => String(n).toLowerCase()));
  return (statuses || []).filter(
    (s) => !blocked.has(String(s.status_name || "").toLowerCase()),
  );
}
